export interface SessionTokenResponse {
  session_token: string;
  session_id: string;
}

export default async function fetchHeygenAccessToken(): Promise<SessionTokenResponse> {
  try {
    const res = await fetch("/api/heygen/token");
    if (!res.ok) {
      throw new Error("Failed to fetch LiveAvatar session token");
    }
    const data: SessionTokenResponse = await res.json();
    return data;
  } catch (error) {
    console.error("Error retrieving session token:", error);
    return { session_token: "", session_id: "" };
  }
}
